//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['conditional'],
    data: function data() {
        return {
            dialog: false,
            alertText: ""
        };
    },

    methods: {
        openModal: function openModal(message) {
            this.dialog = true;
            if (message) this.alertText = message;
            this.$store.commit('collaborators/teams/setShowTable', false);
        },
        closeModal: function closeModal() {
            if (this.conditional == true) {
                var value = Number(this.$route.params.id);
                if (this.$isBoss()) {
                    this.$router.push('/channels/teams/' + value);
                } else if (this.$isSupervisor()) {
                    this.$router.push('/my-team/');
                } else if (this.$isAdmin() || this.$isAdminCollaborator()) {
                    this.$router.push('/bosses/channel/' + value);
                }
            }
            this.dialog = false;
        },
        NewBoss: function NewBoss() {
            this.dialog = true;
            this.alertText = "Nuevo jefe creado con éxito";
        },
        NewChannel: function NewChannel() {
            this.dialog = true;
            this.alertText = "Nuevo canal creado con éxito";
        },
        NewSeller: function NewSeller() {
            this.dialog = true;
            this.alertText = "Nuevo vendedor creado con éxito";
        },
        NewTeam: function NewTeam() {
            this.dialog = true;
            this.alertText = "Nuevo Equipo creado con éxito";
        },
        EditSuccessful: function EditSuccessful() {
            this.dialog = true;
            this.alertText = "Se ha guardado con éxito";
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/alert-modal.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/alert-modal.vue
// module chunks = 4 6 7 8 9 10 11 12